export const PREHEADER_HEIGHT = 70
export const HEADER_DEFAULT_HEIGHT_GE = 56
export const HEADER_DEFAULT_HEIGHT_PE = 70
export const HEADER_SUBHEADER_HEIGHT = 46
